import { Controller } from "@hotwired/stimulus"

// Keep section navigation, autosave drafts and browser history in one workspace.
export default class extends Controller {
  static targets = ["panel", "link", "form", "formPanel", "main"]

  connect() {
    this.navigation = 0
    this.onPop = () => { this.navigation += 1; this.apply(this.current()) }
    window.addEventListener("popstate", this.onPop)
    this.apply(this.current())
  }

  disconnect() { window.removeEventListener("popstate", this.onPop) }

  current() {
    const url = new URL(window.location.href)
    const open = url.searchParams.get("open") || ""
    if (open.startsWith("link-")) return "links"
    if (open.startsWith("answer-")) return "questions"
    if (url.hash === "#for-you") return "people"
    const panel = url.searchParams.get("panel")
    return panel === "social" ? "details" : (panel || "overview")
  }

  navigate(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    this.go(event.currentTarget.dataset.panel)
  }

  async go(panel) {
    const navigation = ++this.navigation
    const forms = document.querySelectorAll('[data-controller~="profile-autosave"]')
    for (const form of forms) {
      const controller = this.application.getControllerForElementAndIdentifier(form, "profile-autosave")
      if (controller && !(await controller.flush())) {
        this.syncSelection()
        return
      }
    }
    if (navigation !== this.navigation) return
    // A new item is explicitly added, so keep its draft editor mounted.
    const draft = document.querySelector('.detail-sidebar .profile-answer-editor-form:not([data-controller~="profile-autosave"])')
    const keepDraft = draft && [...draft.querySelectorAll('input[type="text"], input[type="url"], textarea')].some(field => field.value.trim())
    if (!keepDraft) document.dispatchEvent(new CustomEvent("jane:detail-sidebars-close", { detail: {} }))
    const url = new URL(window.location.href)
    url.searchParams.set("panel", panel)
    if (!keepDraft) url.searchParams.delete("open")
    url.hash = ""
    history.pushState({}, "", url)
    this.apply(panel)
    this.mainTarget.scrollTop = 0
    if (window.innerWidth <= 760) window.scrollTo(0, 0)
  }

  syncSelection() {
    const navigation = this.application.getControllerForElementAndIdentifier(this.element, "you-navigation")
    navigation?.restoreSelection()
  }

  apply(panel) {
    if (!this.panelTargets.some(target => target.dataset.panel === panel)) panel = "overview"
    this.panelTargets.forEach(target => { target.hidden = target.dataset.panel !== panel })
    this.formTarget.hidden = ["links", "questions"].includes(panel)
    this.formPanelTarget.value = panel
    this.linkTargets.forEach(link => {
      const active = link.dataset.panel === panel
      link.classList.toggle("is-active", active)
      if (active) link.setAttribute("aria-current", "page")
      else link.removeAttribute("aria-current")
    })
    this.syncSelection()
  }
}
